import React from 'react';
import { Modal } from '@material-ui/core';
import { isCapitalUI } from 'react-common/theme';
import { CapitalDialog } from '../../../include/react-components/capital/CapitalDialog';
import { _T } from '../../../include/appI18n';
export function PaymentDialog({ open, onClose, children }) {
    if (isCapitalUI) {
        return React.createElement(CapitalDialog, { open: open, onClose: onClose, title: _T.BOOKING_PAYORDER, width: 760, className: "capital-payment-dialog" },
            React.createElement("div", { id: "payment-ui-container" }, children));
    }
    return React.createElement(Modal, { open: open, onClose: onClose },
        React.createElement("div", { className: "modal-dialog modal-lg modal-xl" },
            React.createElement("div", { className: "modal-content custom-modal-content" },
                React.createElement("div", { id: "payment-ui-container" }, children))));
}
